<template>
  <div>
    <admin-nav active="documents-requis" />
    <b-container fluid>
      <b-row class="mb-1">
        <b-col>
          <h3>Documents requis</h3>
          <small class="text-muted">
            Pièces justificatives demandées au client. La visibilité de chaque
            document dépend du type de client et de la situation (création /
            déjà existant). Modifications visibles immédiatement côté parcours.
          </small>
        </b-col>
        <b-col class="text-right">
          <b-button
            variant="primary"
            @click="ouvrirNouveau"
          >
            <feather-icon icon="PlusIcon" /> Nouveau document
          </b-button>
        </b-col>
      </b-row>

      <b-table
        :items="documents"
        :fields="fields"
        striped
        responsive
      >
        <template #cell(categorie)="row">
          {{ libelleCategorie(row.item.categorie) }}
        </template>
        <template #cell(typesClient)="row">
          <b-badge
            v-for="t in row.item.typesClient"
            :key="t"
            variant="light-primary"
            class="mr-50"
          >
            {{ libelleType(t) }}
          </b-badge>
        </template>
        <template #cell(situations)="row">
          <span
            v-if="!row.item.situations.length"
            class="text-muted"
          >
            Toutes
          </span>
          <b-badge
            v-for="s in row.item.situations"
            :key="s"
            variant="light-secondary"
            class="mr-50"
          >
            {{ libelleSituation(s) }}
          </b-badge>
        </template>
        <template #cell(obligatoire)="row">
          <feather-icon
            :icon="row.item.obligatoire ? 'CheckIcon' : 'MinusIcon'"
            :class="row.item.obligatoire ? 'text-success' : 'text-muted'"
          />
        </template>
        <template #cell(actif)="row">
          <b-badge :variant="row.item.actif ? 'success' : 'secondary'">
            {{ row.item.actif ? 'Actif' : 'Inactif' }}
          </b-badge>
        </template>
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-50"
            @click="ouvrirEdition(row.item)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            size="sm"
            :variant="row.item.actif ? 'outline-danger' : 'outline-success'"
            @click="toggleActif(row.item)"
          >
            {{ row.item.actif ? 'Désactiver' : 'Activer' }}
          </b-button>
        </template>
      </b-table>

      <!-- Édition / création document -->
      <b-modal
        v-model="showEdit"
        :title="edit.UI ? 'Modifier le document' : 'Nouveau document'"
        size="lg"
        ok-title="Enregistrer"
        cancel-title="Annuler"
        @ok="enregistrer"
      >
        <b-row>
          <b-col md="8">
            <b-form-group label="Libellé *">
              <b-form-input
                v-model="edit.libelle"
                placeholder="Carte nationale d'identité"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Catégorie *">
              <b-form-select
                v-model="edit.categorie"
                :options="optionsCategorie"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Types de client concernés">
              <b-form-checkbox-group
                v-model="edit.typesClient"
                :options="optionsTypeClient"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Situations concernées">
              <b-form-checkbox-group
                v-model="edit.situations"
                :options="optionsSituation"
              />
              <small class="text-muted">
                Aucune case cochée = document demandé quelle que soit la situation.
              </small>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Obligatoire">
              <b-form-checkbox
                v-model="edit.obligatoire"
                switch
              >
                Pièce obligatoire
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Ordre d'affichage">
              <b-form-input
                v-model.number="edit.ordre"
                type="number"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Description (aide affichée au client)">
              <b-form-textarea
                v-model="edit.description"
                rows="2"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BButton,
  BBadge,
  BModal,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormTextarea,
  BTable,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AdminNav from './AdminNav.vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
    BBadge,
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormTextarea,
    BTable,
    AdminNav,
  },
  data() {
    return {
      documents: [],
      showEdit: false,
      edit: {},
      fields: [
        {
          key: 'ordre',
          label: '#',
        },
        {
          key: 'libelle',
          label: 'Libellé',
        },
        {
          key: 'categorie',
          label: 'Catégorie',
        },
        {
          key: 'typesClient',
          label: 'Types de client',
        },
        {
          key: 'situations',
          label: 'Situations',
        },
        {
          key: 'obligatoire',
          label: 'Obligatoire',
        },
        {
          key: 'actif',
          label: 'Statut',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      optionsCategorie: [
        {
          value: 'personnel',
          text: 'Justificatifs personnels',
        },
        {
          value: 'professionnel',
          text: 'Justificatifs professionnels',
        },
      ],
      optionsTypeClient: [
        {
          value: 'particulier',
          text: 'Particulier',
        },
        {
          value: 'entreprise',
          text: 'Professionnel',
        },
        {
          value: 'association',
          text: 'Association',
        },
      ],
      optionsSituation: [
        {
          value: 'creation',
          text: 'En cours de création',
        },
        {
          value: 'activite',
          text: 'Déjà en activité',
        },
      ],
    }
  },
  created() {
    this.charger()
  },
  methods: {
    authHeaders() {
      return { headers: { 'x-access-token': localStorage.getItem('domAdminToken') } }
    },
    libelleCategorie(c) {
      return ({
        personnel: 'Personnel',
        professionnel: 'Professionnel',
      }[c] || c)
    },
    libelleType(t) {
      return ({
        particulier: 'Particulier',
        entreprise: 'Professionnel',
        association: 'Association',
      }[t] || t)
    },
    libelleSituation(s) {
      return ({
        creation: 'Création',
        activite: 'Déjà existant',
      }[s] || s)
    },
    charger() {
      this.$http.get('/admindom/documents-requis', this.authHeaders())
        .then(response => {
          if (response.data.res === 1) this.documents = response.data.documents
          else this.toast('Erreur de chargement', 'danger', 'AlertTriangleIcon')
        })
    },
    ouvrirNouveau() {
      this.edit = {
        UI: null,
        libelle: '',
        categorie: 'personnel',
        typesClient: ['particulier', 'entreprise', 'association'],
        situations: [],
        obligatoire: false,
        description: '',
        ordre: 100,
      }
      this.showEdit = true
    },
    ouvrirEdition(d) {
      this.edit = {
        ...d,
        typesClient: [...d.typesClient],
        situations: [...d.situations],
      }
      this.showEdit = true
    },
    enregistrer() {
      if (!this.edit.libelle || !this.edit.categorie) {
        this.toast('Libellé et catégorie requis', 'warning', 'AlertTriangleIcon')
        return
      }
      const payload = {
        libelle: this.edit.libelle,
        categorie: this.edit.categorie,
        typesClient: this.edit.typesClient,
        situations: this.edit.situations,
        obligatoire: this.edit.obligatoire,
        description: this.edit.description,
        ordre: this.edit.ordre,
      }
      const req = this.edit.UI
        ? this.$http.patch(`/admindom/documents-requis/${this.edit.UI}`, payload, this.authHeaders())
        : this.$http.post('/admindom/documents-requis', payload, this.authHeaders())
      req.then(response => {
        if (response.data.res === 1) {
          this.toast('Document enregistré', 'success', 'CheckIcon')
          this.charger()
        } else {
          this.toast(response.data.message || 'Erreur', 'danger', 'AlertTriangleIcon')
        }
      })
    },
    toggleActif(d) {
      this.$http.patch(`/admindom/documents-requis/${d.UI}`, { actif: !d.actif }, this.authHeaders())
        .then(response => {
          if (response.data.res === 1) {
            this.toast(d.actif ? 'Document désactivé' : 'Document activé', 'success', 'CheckIcon')
            this.charger()
          }
        })
    },
    toast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          variant,
          icon,
        },
      })
    },
  },
}
</script>
